import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { User } from "@modules/users/types";

import { ListUsersQueryFilters } from "./types";

export async function getUsersService(filters?: ListUsersQueryFilters): Promise<User[]> {
  try {
    const { data } = await api.get<ApiResponse<User>>(`v1/user_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}
